/* eslint-disable @typescript-eslint/naming-convention */
import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';
import { BaseRequestModel } from '../models/base-request.model';


@injectable()
export class FeedbackApi {
    constructor(private readonly httpClient: HttpClient) {
    }

    sendFeedbackNew = async (data: FeedbackRequestModel, cancellationToken?: CancelToken) => {
        return this.httpClient.post<FeedbackResponseModel, FeedbackRequestModel>(
            '/feedback',
            data,
            {
                cancelToken: cancellationToken,
            },
        );
    };
}


export interface FeedbackQuestionModel {
    id?: string;
    content: string;
}

export interface FeedbackRequestModel extends BaseRequestModel {
    job_id: number;
    endpoint_type: 'equipment_chat' | 'chat' | 'troubleshooting_chat';
    message: {
        question: FeedbackQuestionModel,
        answer: string,
        is_helpful: boolean,
        details: string
    };
}

export interface FeedbackResponseModel {
    message: string;
    status: string;
}

